import Header from '../components/Header';

export default function Quote() {
  return (
    <>
      <Header />
      <h3>Daily Quote!</h3>
      <p>Pure mathematics is, in its way, the poetry of logical ideas.— Albert Einstein</p>
    </>
  );
}
